/*
  This file is used to integrate Giosg chat to the website.
  Dependent on files: helpers.js
/*!
 * giosg.js
 */
(function (w, t, f) {
  var s = 'script', o = '_giosg', h = 'https://service.giosg.com', e, n; e = t.createElement(s); e.async = 1; e.src = h + '/live2/' + f;
  w[o] = w[o] || function () { (w[o]._e = w[o]._e || []).push(arguments) }; w[o]._c = f; w[o]._h = h; n = t.getElementsByTagName(s)[0]; n.parentNode.insertBefore(e, n);
})(window, document, "a09dd68e-e779-11e5-b6ba-00163efe97bc");

window.giosgHelper = window.giosgHelper || {};


giosgHelper.logOut = async () => {
  //Remove all relevant data of the customer from every room
  const roomSet = new Set();
  giosg.rules
    .map((x) => x.targetRooms)
    .flat()
    .forEach((item) => {
      if (item) {
        roomSet.add(item);
      }
    });

  roomSet.forEach((room) => _giosg('visitor', 'removeAll', { id: room }));

  setTimeout(() => {
    _giosg('visitor', 'submit', { username: 'unregistered', order_link: '' });
    _giosg('chat', 'close', { hide: true });
  }, 1000);
}

giosgHelper.createAndSubmitCounselingTag = (productName) => {
  const currentDate = new Date();
  let tag = "neuvonta_KORJAATUOTENIMI_" + currentDate.getDate() + "." + (currentDate.getMonth() + 1) + "." + currentDate.getFullYear();
  if (productName) {
    tag = tag.replace("KORJAATUOTENIMI", productName);
    window.theme_helpers.product_name = null;
  }
  setTimeout(function () {
    _giosg('visitor', 'submit', { product_counseling_tag: tag }, 'plain');
  }, 500);
}

giosgHelper.hideChatWindow = function () {
  _giosg('chat', 'hide');
};

giosgHelper.openChatWindow = function () {
  const giosgButton = document.querySelector('#giosg_chat_now_button');
  if (giosgButton) {
    giosgButton.click();
  } else {
    setTimeout(function () {
      giosgHelper.openChatWindow();
    }, 500);
  }
}

giosgHelper.addCartToGiosg = async(cart) => {
  if (cart === undefined) {
    cart = await helpers.api.getCart();
  }

  const products = cart.items.map((item) => {
    return { price: (item.discounted_price / 100).toString(), quantity: item.quantity, name: item.title };
  });

  _giosg(function () {
    giosg.api.shoppingCart
      .submit(products).then(function () {});
  })
}

giosgHelper.addBrowserDataToGiosg = () => {
  let userAgent = navigator.userAgent.toLowerCase();
  // Figure out what browser is being used
  let browser = {
    version: (userAgent.match(/.+(?:rv|it|ra|ie|me|ve)[\/: ]([\d.]+)/) || [])[1],
    chrome: /chrome/.test(userAgent),
    safari: /webkit/.test(userAgent) && !/chrome/.test(userAgent),
    opera: /opera/.test(userAgent),
    firefox: /firefox/.test(userAgent),
    android: /android/.test(userAgent),
    androidVersion: (userAgent.match(/.+(?:android)[\/: ]([\d.]+)/) || [0, 0])[1],
    iphone: /iphone|ipod/.test(userAgent),
    iphoneVersion: (userAgent.match(/.+(?:iphone\ os)[\/: ]([\d_]+)/) || [0, 0])[1].toString().split('_').join('.'),
    ipad: /ipad/.test(userAgent),
    ipadVersion: (userAgent.match(/.+(?:cpu\ os)[\/: ]([\d_]+)/) || [0, 0])[1].toString().split('_').join('.'),
    blackberry: /blackberry/.test(userAgent),
    winMobile: /Windows\ Phone/.test(userAgent),
    winMobileVersion: (userAgent.match(/.+(?:windows\ phone\ os)[\/: ]([\d_]+)/) || [0, 0])[1]
  };
  browser.mobile = browser.iphone || browser.ipad || browser.android || browser.blackberry;

  Object.keys(browser).filter((e) => {
    return !e.toLowerCase().includes('version');
  }).forEach(function (key) {
    if (browser[key]) {
      _giosg('visitor', 'submit', { browser: key, 'browser version': browser[key + 'version'] || browser.version });
      return null;
    }
  });
}


let tries = 0;
giosgHelper.addButtonListener = () => {
  const button = document.querySelector('#giosg_chat_now_button');
  if (button) {
    button.addEventListener('click', () => {
      apteekkiplus.api.createDraftOrder();
    });
  }
  else if (tries < 60) {
    tries++;
    setTimeout(giosgHelper.addButtonListener, 500);
  }
};

giosgHelper.addButtonListener();

// 
giosgHelper.addCartToGiosg();
giosgHelper.addBrowserDataToGiosg();
if(helpers.getUrlParameter('action') === 'open_chat_window') {
  giosgHelper.openChatWindow();
}

document.addEventListener('cart:update', (event) => {
  giosgHelper.addCartToGiosg(event.detail);
  const chat = window.GiosgClient.activeChat;
  if (chat?.id) {
    apteekkiplus.api.createDraftOrder();
  }
});

document.addEventListener('ajaxProduct:added', () => {
  giosgHelper.addCartToGiosg();
  const chat = window.GiosgClient?.activeChat;
  if (chat?.id) {
    apteekkiplus.api.createDraftOrder();
  }
});